var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"mapWrap",class:['map-wrap', {'out-system-load': _vm.outSistemLoad || _vm.hasCountryInfo}]},[_c('tour-map',{attrs:{"rate":_vm.rate,"focused":_vm.focusedMapItem,"mapItems":_vm.mapItems},on:{"buyTour":function($event){return _vm.buyTour($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }